import { render, staticRenderFns } from "./KitTabsContainer.vue?vue&type=template&id=d906a2dc"
import script from "./KitTabsContainer.vue?vue&type=script&lang=js"
export * from "./KitTabsContainer.vue?vue&type=script&lang=js"
import style0 from "./KitTabsContainer.vue?vue&type=style&index=0&id=d906a2dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports